import { DateHelper as e } from "./chunk335.js";
const m = (t) => `${t}?t=${e.getTimestamp()}`;
export {
  m as setTimestampToUrl
};
